import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="about-hero"
        eyebrow="About Wikificial"
        title="The Encyclopedia of AI."
        sub="An honest, editor-scored directory of every AI tool worth knowing about — paired with Wikifi, a multi-model synthesis engine that picks the right AI for the job."
      />

      <div className="grid md:grid-cols-3 gap-4 mb-8" data-testid="about-stats">
        {[
          { label: "Tools tracked",     value: "28,655+" },
          { label: "Editor-verified",   value: "8,200+" },
          { label: "Categories",        value: "28" },
        ].map(s => (
          <div key={s.label} className="rounded-xl bg-white border border-[#E7EAF0] p-5">
            <div className="text-[10px] uppercase tracking-widest text-[#5B6478] font-bold mb-1">{s.label}</div>
            <div className="font-display text-2xl font-bold text-[#0B1220]">{s.value}</div>
          </div>
        ))}
      </div>

      <section className="space-y-8 text-[#0B1220] text-[14px] leading-relaxed" data-testid="about-body">
        <div>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Why we built this</h2>
          <p className="text-[#5B6478]">
            The AI space moves faster than any human can track. Every week
            there's a new "ChatGPT killer" or "10 tools that will change your
            life." Most of them are noise. Wikificial exists to be the calm,
            honest reference — the one place you can go, search for what you
            actually need, and get a straight answer.
          </p>
        </div>

        <div>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">How the scoring works</h2>
          <p className="text-[#5B6478]">
            Every tool gets two independent scores: <strong className="text-[#0B1220]">Wikifi Score</strong> (our
            editorial signal — capability, reliability, ecosystem fit) and
            <strong className="text-[#0B1220]"> User Score</strong> (aggregated real-world reviews). They rarely agree
            perfectly, and that's the point. If you want the full methodology,
            it's in the <Link to="/methodology" className="text-[#F97316] hover:underline font-semibold">Methodology</Link> page.
          </p>
        </div>

        <div>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Wikifi — the workspace layer</h2>
          <p className="text-[#5B6478]">
            Wikifi is the synthesis engine. Ask a question once, and Wikifi Auto
            fans it out to the top frontier models (ChatGPT, Claude, Gemini,
            Grok, Perplexity), reconciles their answers, and gives you one
            clean, verifiable response. Or pick a specific model if you want.
          </p>
        </div>

        <div>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Contact & feedback</h2>
          <p className="text-[#5B6478]">
            Missing a tool? See a bad score? Something broken? Tell us at{" "}
            <Link to="/contact" className="text-[#F97316] hover:underline font-semibold">/contact</Link> or
            email <a href="mailto:contact@wikifi.app" className="text-[#F97316] hover:underline font-semibold">contact@wikifi.app</a>.
            We read everything.
          </p>
        </div>
      </section>
    </Layout>
  );
}
